import { SalonAnalysis } from './salon-analysis'

/**
 * Plus Salon Analysis - wrapper component using shared SalonAnalysis
 */
const PlusSalonAnalysis = () => {
  return <SalonAnalysis operator="plus" />
}

export default PlusSalonAnalysis
